import { InviteProgramStatusEnum } from '@/services/api-clients';

export function inviteProgramStatusColorFilter(type: InviteProgramStatusEnum): [string, string] {
    switch(type) {
        case InviteProgramStatusEnum.Upcome: return ['warning', 'warning--text'];
        case InviteProgramStatusEnum.Active: return ['success', 'success--text'];
        case InviteProgramStatusEnum.Finished: return ['primary', 'primary--text'];
    }
}